import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const ContactPersonPhoneCellContent: React.FC<
	ContactPersonPhoneCellContent.Props
> = ({ item }) => {
	const content = useMemo(
		() => item.additionalFields?.contactPersonPhone ?? "",
		[item.additionalFields?.contactPersonPhone],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ContactPersonPhoneCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default ContactPersonPhoneCellContent;
